import { render, staticRenderFns } from "./new_password.vue?vue&type=template&id=7c9c77e7&scoped=true&"
import script from "./new_password.vue?vue&type=script&lang=js&"
export * from "./new_password.vue?vue&type=script&lang=js&"
import style0 from "./new_password.vue?vue&type=style&index=0&id=7c9c77e7&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c9c77e7",
  null
  
)

export default component.exports